import { CourseTrainerPriceApi } from "api/types";
import { formatDate, fromTimeFormat } from "utils";

export interface SessionGroup {
  courseSessionId: number;
  label: string;
  hours: number;
  prices: CourseTrainerPriceApi[];
}

const getHours = (price: CourseTrainerPriceApi) => (fromTimeFormat(price.timeTo) - fromTimeFormat(price.timeFrom)) / 60;

// Groups lecture-level prices into one row per zjazd (CourseSessionId), with the zjazd's
// name, its date span (from the earliest to the latest lecture in it) and total hours.
export const groupPricesBySession = (prices: CourseTrainerPriceApi[]): SessionGroup[] => {
  const bySession = new Map<
    number,
    { courseSessionId: number; name: string; hours: number; prices: CourseTrainerPriceApi[]; from: Date; to: Date }
  >();

  prices.forEach((price) => {
    const hours = getHours(price);
    const date = new Date(price.date);
    const existing = bySession.get(price.courseSessionId);
    if (existing) {
      existing.hours += hours;
      existing.prices.push(price);
      if (date < existing.from) existing.from = date;
      if (date > existing.to) existing.to = date;
    } else {
      bySession.set(price.courseSessionId, {
        courseSessionId: price.courseSessionId,
        name: price.courseSessionName,
        hours,
        prices: [price],
        from: date,
        to: date,
      });
    }
  });

  return Array.from(bySession.values())
    .sort((a, b) => a.from.getTime() - b.from.getTime())
    .map(({ courseSessionId, name, hours, prices: sessionPrices, from, to }) => {
      const fromLabel = formatDate(from, false, false, "short");
      const toLabel = formatDate(to, false, false, "short");
      return {
        courseSessionId,
        label: `${name} — ${fromLabel === toLabel ? fromLabel : `${fromLabel} – ${toLabel}`}`,
        hours,
        prices: sessionPrices,
      };
    });
};
